import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=3b0c08ac&scoped=true&"
import script from "./BillOfLading.vue?vue&type=script&lang=ts&"
export * from "./BillOfLading.vue?vue&type=script&lang=ts&"
import style0 from "./BillOfLading.vue?vue&type=style&index=0&id=3b0c08ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c08ac",
  null
  
)

export default component.exports